(function () {
    var alerts, dismissButtons;
    var storedAlertIds = localStorage.getArray('nhsenglandDismissedAlertBanners');

    alerts = document.querySelectorAll('.alert-banner');
    dismissButtons = document.querySelectorAll('.banner-dismiss');

    $('.alert-banner').removeClass("banner-visible");

    alerts.forEach(function(alert) {
        if (!alert) {
            return;
        }

        alert.setAttribute('aria-hidden', 'true');

        var alertId = alert.getAttribute('data-id');
        if (!storedAlertIds.includes(alertId)) {
            $('#banner-' + alertId).addClass("banner-visible");
            alert.setAttribute('aria-hidden', 'false');
        }
    });

    dismissButtons.forEach(function(dismissButton) {
        dismissButton.addEventListener('click', function () {
            var buttonId = $(this).data('id');
            if (window.matchMedia('(prefers-reduced-motion: reduce)')) {
                $('#banner-' + buttonId).removeClass("banner-visible");
            } else {
                $('#banner-' + buttonId).slideToggle("slow");
            }
            localStorage.pushArrayItem('nhsenglandDismissedAlertBanners', buttonId);
        });
    });
}());